export default "__VITE_ASSET__DQ6_juA___";